/* eslint-disable @faire/enforce-internal-folder-encapsulation */
import { useSDUISearchSuggestionsEmptyState } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/fetchSDUISearchSuggestionsEmptyState";
import { getRetailer } from "@faire/retailer-visitor-shared/serialized-data/getRetailer";

export const SDUISearchDropdownEmptyState = () => {
  const retailerToken = getRetailer()?.token ?? "";
  useSDUISearchSuggestionsEmptyState(retailerToken);
  return null;
};
